import { Button } from 'src/components/Button/Button.component';
import { ButtonContainer } from 'src/components/Button/style/Button.style';
import Icon from 'src/components/Icon/Icon.component';
import NeedHelpButton from 'src/components/NeedHelpButton/NeedHelpButton.component';
import Translate from 'src/components/Translate/Translate.component';
import { ReactComponent as WrongUser } from 'src/images/pageStatus/wrong_user.svg';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutePath } from 'src/routers/routers.config';
import { H4 } from 'src/style-utils/typographic';
import useQueryParams from 'src/utils/hooks/useQueryParams';
import { ErrorPagePar } from '../style/failedPage.style';
import { useProfileStore } from 'src/store/store';
import { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'src/style-utils/functions';

const SignWrongUser: React.FC = () => {
  const { firstName, lastName } = useQueryParams();
  const AccountType = useProfileStore((state) => state.AccountType);
  const navigate = useNavigate();
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <Icon
        svgIconComponent={WrongUser}
        iconHeight="auto"
        iconSize="min(100%, 25.6rem)"
        margin="4.2rem auto"
      />
      <H4 textAlign="center">
        <Translate id="text.wrongUserTitle" />
      </H4>
      <ErrorPagePar>
        <Translate id="text.wrongUserSubtitle" data={{ firstName, lastName }} />
      </ErrorPagePar>
      <ButtonContainer>
        <Button
          variant="Primary"
          minWidth="32.7rem"
          onClick={() => {
            navigate(`${RoutePath.privateArea}?typeAccount=${AccountType}`);
          }}
        >
          <Translate id="lbl.backHomePage" />
        </Button>
        <NeedHelpButton />
      </ButtonContainer>
    </StyleSheetManager>
  );
};

export default SignWrongUser;
